<template>
  <div class="main" ref="overviewMap">
    <div class="device-container">
      <div style="width: calc(100vw);"
           :style="{'min-height':indoorType==='list'?'27vh':'calc(100vh - 105px)','height':indoorType==='list'?'27vh':'calc(100vh - 105px)'}" id="myMap"
           ref="myMap"></div>
    </div>
  </div>
</template>

<script>
import {getSpaceInfoById} from "@/network/space-info";
import {getDeviceListBySpaceIdAndCategoryTagId} from "@/network/device-info";
import {getSpaceMap} from "@/network/space-map";
import 'ol/ol.css';
import Map from 'ol/Map';
import View from 'ol/View';
import ImageLayer from "ol/layer/Image";
import {ImageStatic} from "ol/source";
import {Projection} from "ol/proj";
// import {getCenter} from "ol/extent";
import * as olInteraction from 'ol/interaction'
import DragRotateAndZoom from 'ol/interaction/DragRotateAndZoom'
import VectorSource from "ol/source/Vector";
import VectorLayer from "ol/layer/Vector";
import {LineString, Point} from "ol/geom";
import {createStringXY} from "ol/coordinate";
import {FullScreen, MousePosition} from "ol/control";
import {defaults as defaultControls} from "ol/control";
import Zoom from "ol/control/Zoom";
import {Icon, Stroke, Style} from 'ol/style';
// import Fill from "ol/style/Fill";
import Feature from 'ol/Feature';

export default {
  name: "IndoorSetting",
  props: {
    spaceId: {
      type: String,
      default: () => '0'
    },
    categoryTagId: {
      type: String,
      default: () => null
    },
    indoorType: {
      type: String,
      default: () => null
    },
    screenDatas: {
      type: Array,
      default: () => []
    },
    highlightDeviceId: {
      type: String,
      default: () => ''
    }
  },
  data() {
    return {
      spaceInfo: {},
      spaceMap: [],
      deviceListWidthId: null,
      deviceListId: [],
      // 当前鼠标移动到的设备
      currentSelectDeviceId: 0,
      // 定时器遍历选择设备效果
      timerSelectDeviceId: 0,
      // 定时器当前选中的下表
      timerSelectDeviceIndex: 0,
      imgWidth: 0,
      imgHeight: 0,
      initWidth: 0,
      initHeight: 0,
      // 地图初始化放大倍数
      initZoom: 1,
      // 背景图比地图大时默认倍数
      overZoom: 2,
      // 背景图是否比地图大标识
      overFlag: false,
      /* start
      *GIS地图参数*/
      map: null, // 地图
      // 鼠标点击事件对象
      mapClickHandler: null,
      // 鼠标悬浮事件对象
      mapOverHandler: null,
      // 漏水线图层集合
      slackLineLayers: [],
      imgx: 1432, // 当前地图宽
      imgy: 1002, // 当前地图高
      // 鼠标坐标管理器
      mousePositionControl: "",
      // 地图背景图层
      mapImageLayers: null,
      // 图标管理器
      iconLayer: null,
      // 鼠标悬浮图层
      hoverFeature: null,
      // 图标集合
      featureList: [],
      // 定时更新设备图标
      updateDeviceIconTimer: null,
      // 设备集合
      deviceList: [],
      styleCache: {},
      // 新增: 预加载机制
      iconPreloadQueue: null,
      zoomInteraction: null,  // 存储缩放交互引用
      // 高亮设备相关
      highlightFeature: null, // 当前高亮的设备要素
      highlightTimer: null,   // 高亮闪烁定时器
      /* end
      *GIS地图参数*/
    }
  },
  methods: {
    // getDeviceValueByDeviceIds(deviceIds) {

    // },
    // 重新设置底图和设备图标
    changeDeviceMapImage() {
      // 重新设置地图背景图层
      this.getMapImageLayer();
      this.map.addLayer(this.mapImageLayers);
      
      // 初始化图标图层
      this.initDevicePointList();
      
      // 使用fit方法自动适应视图到图像范围
      const extent = [0, 0, this.imgx, this.imgy];
      this.map.getView().fit(extent, {
        size: [this.$refs.overviewMap.clientWidth, this.$refs.overviewMap.clientHeight],
        padding: [10, 10, 10, 10],
        constrainResolution: false
      });
    },
    // 获取内景图图片宽高
    async getBgImageInfo(fucObject) {
      // 图片地址 后面加时间戳是为了避免缓存
      var img_url = this.spaceInfo === undefined || this.spaceInfo === null || this.spaceInfo.bgImage === null || this.spaceInfo.bgImage === '' ? require('@/assets/images/no-bg.png') : this.$ftpUrl + this.spaceInfo.bgImage  // 静态地图
      // 创建对象
      var img = new Image();
      // 改变图片的src
      img.src = img_url;
      var that = this;
      // 加载完成执行
      img.onload = await function () {
        that.imgy = img.height
        that.imgx = img.width
        fucObject()
      }
    },
    // 定时器选择设备事件
    timerSelectDevice() {
      if (this.deviceListId.length <= 0) {
        return
      }
      if (this.timerSelectDeviceIndex > this.deviceListId.length - 1) {
        this.timerSelectDeviceIndex = 0
      }
      this.timerSelectDeviceId = this.deviceListId[this.timerSelectDeviceIndex++]
    },
    getDeviceList(spaceId) {
      getDeviceListBySpaceIdAndCategoryTagId(spaceId, this.categoryTagId).then(res => {
        if (res.data) {
          this.deviceList = []
          this.deviceList = res.data
          if (this.screenDatas.length > 0) {
            this.screenDatas.forEach(item => {
              this.deviceList = this.deviceList.filter(e => e.typeCnName !== item.typeCnName)
            })
          }
          this.checkDeviceValueOrPosition();
          this.deviceListWidthId = {}
          this.deviceListId = []
          this.deviceList.forEach(device => {
            this.deviceListId.push(device.id)
            this.deviceListWidthId[device.id] = device
          })
          
          // 预加载图标资源
          this.preloadAllIconResources();
          
          this.getSpaceMap(this.spaceInfo.id)
        }
      })
    },
    getSpaceMap(spaceId) {
      if (spaceId === '' || spaceId === null || spaceId === undefined) {
        return
      }
      getSpaceMap(spaceId).then(res => {
        if (res.data) {
          this.spaceMap = res.data
          this.addSlacklineList()
        }
      })
    },
    // 通过空间id获取空间信息
    async getSpaceInfo(id) {
      if (id === '') {
        return
      }
      await getSpaceInfoById(id).then(async res => {
        if (res.data) {
          this.spaceInfo = res.data
          await this.getDeviceList(this.spaceInfo.id)
        }
      })
    },
    showDeviceDetails(deviceId) {
      this.$emit("showDeviceDetail", deviceId)
    },
    // 设置地图背景图片
    getMapImageLayer() {
      let extent = [0, 0, this.imgx, this.imgy];  // 获取图片的宽高
      // [minx, miny, maxx, maxy].
      let projection = new Projection({
        code: "xkcd-image",
        units: "pixels",
        extent: extent
      });
      this.mapImageLayers = null;
      this.mapImageLayers = new ImageLayer({
        source: new ImageStatic({
          url: this.spaceInfo === undefined || this.spaceInfo === null || this.spaceInfo.bgImage === null || this.spaceInfo.bgImage === '' ? require('@/assets/images/no-bg.png') : this.$ftpUrl + this.spaceInfo.bgImage,  // 静态地图
          projection: projection,
          imageExtent: extent
        })
      })
    },
    // 初始化GIS地图 - 使用fit()方法自动适应容器
    async initMap() {
      // 定义投影和范围
      let extent = [0, 0, this.imgx, this.imgy];
      let projection = new Projection({
        code: "xkcd-image",
        units: "pixels",
        extent: extent
      });
      
      // 设置地图背景图层
      this.mapImageLayers = new ImageLayer({
        source: new ImageStatic({
          url: this.spaceInfo === undefined || this.spaceInfo === null || this.spaceInfo.bgImage === null || this.spaceInfo.bgImage === '' ? require('@/assets/images/no-bg.png') : this.$ftpUrl + this.spaceInfo.bgImage,
          projection: projection,
          imageExtent: extent
        })
      });
      
      // 创建视图，但不设置缩放和中心 - 将通过fit()方法设置
      const view = new View({
        projection: projection,
        maxZoom: 7,
        minZoom: 0.1
      });
      
      // 创建地图
      this.map = new Map({
        target: "myMap",
        interactions: olInteraction.defaults().extend([new DragRotateAndZoom()]),
        view: view,
        controls: defaultControls({
          rotate: true,
        }).extend([
          new FullScreen({ tipLabel: "全屏" }),
          new Zoom({
            zoomInTipLabel: "放大",
            zoomOutTipLabel: "缩小"
          })
        ])
      });
      
      // 添加背景图层
      this.map.addLayer(this.mapImageLayers);
      
      // 使用fit方法自动适应视图到图像范围
      // 添加小边距(10px)并设置最大缩放级别
      view.fit(extent, {
        size: [this.$refs.overviewMap.clientWidth, this.$refs.overviewMap.clientHeight],
        padding: [10, 10, 10, 10],
        constrainResolution: false
      });
      
      // 添加图标集合
      this.addDevicePointList();
      
      // 添加增强图标在缩放时的可见性
      this.enhanceIconsVisibilityDuringZoom();
      
      // 修改旋转鼠标悬浮tip
      if (document.getElementsByClassName('ol-rotate-reset')[0]) {
        document.getElementsByClassName('ol-rotate-reset')[0].attributes.title.nodeValue = '重置旋转';
      }
      
      // 地图初始化完成
    },
    // 添加鼠标悬浮地图中坐标
    addMousePosition() {
      this.removeMousePosition()
      this.mousePositionControl = new MousePosition({
        coordinateFormat: function (e) { // 这里格式化成 X: **  Y: **
          // 将坐标保留4位小数位，并转换为字符串
          let stringifyFunc = createStringXY(4)
          let str = stringifyFunc(e)
          return 'X: ' + str.split(',')[0] + '&nbsp;' + ' Y: ' + str.split(',')[1]
        },
        projection: 'EPSG:4326', // 和地图坐标系保持一致
        className: 'custom-mouse-position', // css类名
        target: document.getElementById('mousePosition') // 显示位置鼠标坐标位置DOM
      })
      // 添加控制控件到地图上即可
      this.map.addControl(this.mousePositionControl)
    },
    // 移除鼠标位置
    removeMousePosition() {
      if (this.mousePositionControl) {
        // 移除
        this.map.removeControl(this.mousePositionControl)
        this.mousePositionControl = null
      }
    },
    // 添加图标
    addDevicePoint(item) {
      let convertX = item.xoffset * this.imgx / 100;
      let convertY = this.imgy - (item.yoffset * this.imgy / 100);
      const iconFeature = new Feature({
        geometry: new Point([convertX, convertY])
      });
      
      const deviceInfo = this.deviceListWidthId[item.deviceId];
      if (!deviceInfo) return; // 防止空引用
      
      // 预加载图标资源，避免后续渲染闪烁
      const normalIcon = new Image();
      const alarmIcon = new Image();
      
      normalIcon.src = this.$ftpUrl + deviceInfo.icon;
      alarmIcon.src = this.$ftpUrl + deviceInfo.iconAlarm;
      
      // 获取设备名称和详情内容
      const titleText = item.deviceName;
      const deviceMeasuringPointHistoryList = deviceInfo.deviceMeasuringPointHistoryList || [];
      const detailsText = deviceMeasuringPointHistoryList.length > 0 
        ? deviceMeasuringPointHistoryList.map(point => 
        `${point.pointName}：${point.pointValueName}`
          ).join('\n')
        : '';
      
      // 创建三种状态的样式缓存标识
      const iconOnlyKey = `${deviceInfo.id}_${deviceInfo.status}_iconOnly`;  // 仅图标
      const detailsOnlyKey = `${deviceInfo.id}_${deviceInfo.status}_detailsOnly`;  // 图标+详情(无名称)
      const hoverStyleKey = `${deviceInfo.id}_${deviceInfo.status}_hover`;  // 图标+名称+详情
      
      if (!this.styleCache) this.styleCache = {};
      
      // 1. 创建仅图标样式（无文本）
      if (!this.styleCache[iconOnlyKey]) {
        // 使用固定的图像对象而不是每次重新加载
        this.styleCache[iconOnlyKey] = [
          new Style({
            image: new Icon({
              anchorXUnits: 'fraction',
              anchorOrigin: 'bottom-left',
              anchorYUnits: 'fraction',
              anchor: [0.5, 0],
              src: deviceInfo.status === 0 ? 
                this.$ftpUrl + deviceInfo.icon : 
                this.$ftpUrl + deviceInfo.iconAlarm,
              scale: 1
            }),
            zIndex: 3
          })
        ];
      }
      
      // 2. 创建仅详情样式（图标+详情，无名称）
      if (!this.styleCache[detailsOnlyKey] && deviceMeasuringPointHistoryList.length > 0) {
        this.styleCache[detailsOnlyKey] = this.createDeviceStyle(deviceInfo, null, detailsText);
      }
      
      // 3. 创建悬停样式（图标+名称+详情）
      if (!this.styleCache[hoverStyleKey]) {
        // 特别处理报警状态的设备
        if (deviceInfo.status !== 0) {
          // 确保图标资源已加载
          const img = new Image();
          img.src = this.$ftpUrl + deviceInfo.iconAlarm;
          
          // 为报警状态设备创建特殊样式
          const iconStyle = new Style({
            image: new Icon({
              anchorXUnits: 'fraction',
              anchorOrigin: 'bottom-left',
              anchorYUnits: 'fraction',
              anchor: [0.5, 0],
              src: this.$ftpUrl + deviceInfo.iconAlarm,
              scale: 1
            }),
            zIndex: 3
          });
          
          // 创建文本样式
          const textStyles = this.createDeviceStyle(deviceInfo, titleText, detailsText);
          
          // 合并样式，确保图标在前面
          this.styleCache[hoverStyleKey] = [iconStyle, ...textStyles];
        } else {
          // 正常状态设备使用普通样式
          this.styleCache[hoverStyleKey] = this.createDeviceStyle(deviceInfo, titleText, detailsText);
        }
      }
      
      // 设置初始样式：有详情显示详情，无详情只显示图标
      iconFeature.setStyle(
        deviceMeasuringPointHistoryList.length > 0 ? 
          this.styleCache[detailsOnlyKey] : 
          this.styleCache[iconOnlyKey]
      );
      
      // 存储样式键值以便悬停时使用
      iconFeature.iconOnlyKey = iconOnlyKey;
      iconFeature.detailsOnlyKey = detailsOnlyKey;
      iconFeature.hoverStyleKey = hoverStyleKey;
      iconFeature.hasDetails = deviceMeasuringPointHistoryList.length > 0;
      
      // 设置属性
      iconFeature.deviceName = item.deviceName;
      iconFeature.deviceId = item.deviceId;
      iconFeature.id_ = item.id;
      
      this.featureList.push(iconFeature);
    },
    // 添加设备图标集合
    initDevicePointList() {
      // 清除GIS地图中图标更新器
      if (this.updateDeviceIconTimer) {
        clearTimeout(this.updateDeviceIconTimer);
        this.updateDeviceIconTimer = null;
      }
      
      // 清除点位
      this.delDevicePoint();
      
    // 添加图标集合 - 增强数据就绪检查
    const hasSpaceMap = this.spaceMap && this.spaceMap.length > 0;
    const hasDeviceList = this.deviceListWidthId && Object.keys(this.deviceListWidthId).length > 0;
    
    if (hasSpaceMap && hasDeviceList) {
      this.addDevicePointList();
      return;
    }
    
    // 使用setTimeout递归，比setInterval有更好的控制
    // 设置最大重试次数，避免无限递归
    if (!this._initDevicePointRetryCount) {
      this._initDevicePointRetryCount = 0;
    }
    
    if (this._initDevicePointRetryCount < 20) { // 最多重试20次（10秒）
      this._initDevicePointRetryCount++;
      this.updateDeviceIconTimer = setTimeout(() => {
        this.initDevicePointList();
      }, 500);
    } else if (this._initDevicePointRetryCount < 100) {
      // 如果重试次数在合理范围内失败，显示警告
      console.warn('设备图标初始化超时，数据未准备就绪。hasSpaceMap:', hasSpaceMap, 'hasDeviceList:', hasDeviceList);
      this._initDevicePointRetryCount = 0;
    }
    // 如果 _initDevicePointRetryCount >= 100，说明是故意设置的（如空间信息获取失败），不显示警告
    },
    // 初始化设备图标集合图层
    addDevicePointList() {
      const vectorSource = new VectorSource()
      this.iconLayer = new VectorLayer({
        source: vectorSource,
        // 增加以下配置提高缩放时的性能
        updateWhileAnimating: true,  // 动画过程中更新
        updateWhileInteracting: true, // 交互过程中更新
        renderMode: 'image',         // 使用图片模式提高性能
        zIndex: 10                   // 确保在高层级绘制
      })
      let deviceIconList = null;
      deviceIconList = this.spaceMap.filter(item => item.xoffset && item.yoffset && this.deviceListWidthId[item.deviceId] && this.deviceListWidthId[item.deviceId].typeEngName !== 'PM_WLD')
      deviceIconList.forEach(item => {
        this.addDevicePoint(item);
      })
      // 等待图标图层添加完再绑定鼠标悬浮和点击事件
      if (this.featureList !== null && this.featureList.length !== 0) {
        // 将图标数组添加到图层中
        this.iconLayer.getSource().addFeatures(this.featureList)
        
        // 添加图层 - 增强检查
        if (this.map) {
          this.map.addLayer(this.iconLayer);
          console.log(`成功添加 ${this.featureList.length} 个设备图标`);
          
          this.mapOver();
          this.mapClick();
          
          // 如果有需要高亮的设备，在设备加载完成后执行高亮
          if (this.highlightDeviceId) {
            setTimeout(() => {
              this.highlightDevice(this.highlightDeviceId);
            }, 800); // 增加延迟，确保设备已完全渲染
          }
          
          // 重置重试计数器
          this._initDevicePointRetryCount = 0;
        } else {
          console.error('地图对象不存在，无法添加设备图标图层。可能原因：空间ID无效或空间信息获取失败');
          // 停止继续重试
          this._initDevicePointRetryCount = 999;
        }
      } else {
        console.warn('没有可显示的设备图标，featureList长度:', this.featureList ? this.featureList.length : 0);
      }
    },
    // 根据id_删除图标并清除该图层所有点击和悬浮事件
    delDevicePoint() {
      // 初始化设备点位集合图层
      this.featureList = [];
      if (this.map && this.iconLayer !== null && this.iconLayer.getSource()) {
        const features = this.iconLayer.getSource().getFeatures();
        if (features.length !== 0) {
          // 安全地解绑事件处理器
          if (this.mapOverHandler) {
            this.map.un('pointermove', this.mapOverHandler);
          }
          if (this.mapClickHandler) {
            this.map.un('singleclick', this.mapClickHandler);
          }
          // 安全地移除所有要素
          features.forEach(item => {
            if (item && item.id_) {
              const feature = this.iconLayer.getSource().getFeatureById(item.id_);
              if (feature) {
                this.iconLayer.getSource().removeFeature(feature);
              }
            }
          });
        }
      }
    },
    // 鼠标悬停
    mapOver() {
      const _this = this;
      let lastHoverFeature = null; // 记录上一次悬停的要素
      let hoverTimeout = null; // 防抖动的定时器
      
      this.mapOverHandler = evt => {
        var pixel = _this.map.getEventPixel(evt.originalEvent);
        var hit = _this.map.hasFeatureAtPixel(pixel);
        this.$refs.myMap.style.cursor = hit ? 'pointer' : '';
        
        // 获取当前悬停的要素
        var currentFeature = _this.map.forEachFeatureAtPixel(evt.pixel,
          function (feature) {
            return feature;
          });
        
        // 如果悬停要素没变化，不做处理，减少不必要的样式更新
        if (currentFeature === lastHoverFeature) {
          return;
        }
        
        // 清除之前的定时器
        if (hoverTimeout) {
          clearTimeout(hoverTimeout);
        }
        
        // 设置防抖动处理，延迟更新样式
        hoverTimeout = setTimeout(() => {
          // 更新记录的悬停要素
          lastHoverFeature = currentFeature;
          
          // 遍历所有要素，处理样式
          this.featureList.forEach(feature => {
            try {
              // 判断当前要素是否是鼠标悬停的要素
              if (feature === currentFeature) {
                // 对悬停要素应用悬停样式
                const deviceInfo = this.deviceListWidthId[feature.deviceId];
                console.log(deviceInfo);
                // 确保悬停元素的zIndex高于其他元素
                if (this.styleCache[feature.hoverStyleKey]) {
                  // 提高悬停状态的zIndex
                  this.styleCache[feature.hoverStyleKey].forEach(style => {
                    style.setZIndex(style.getZIndex() + 100);
                  });
                }
                
                feature.setStyle(this.styleCache[feature.hoverStyleKey]);
              } else {
                // 对非悬停要素恢复默认样式
                const styleKey = feature.hasDetails ? feature.detailsOnlyKey : feature.iconOnlyKey;
                feature.setStyle(this.styleCache[styleKey]);
              }
            } catch (error) {
              console.error('设置样式时出错:', error);
            }
          });
        }, 50); // 添加50ms延迟，减少频繁更新
      };
      
      // 加入mouseleave事件处理，确保鼠标离开地图时所有要素恢复默认样式
      this.$refs.myMap.addEventListener('mouseleave', () => {
        // 清除悬停状态
        lastHoverFeature = null;
        if (hoverTimeout) {
          clearTimeout(hoverTimeout);
        }
        
        // 恢复所有要素默认样式
        this.featureList.forEach(feature => {
          try {
            const styleKey = feature.hasDetails ? feature.detailsOnlyKey : feature.iconOnlyKey;
            // 确保样式存在
            if (this.styleCache[styleKey]) {
              feature.setStyle(this.styleCache[styleKey]);
            }
          } catch (error) {
            console.error('重置样式时出错:', error);
          }
        });
      });
      
      this.map.on('pointermove', this.mapOverHandler);
    },
    // 监听地图点击事件
    mapClick() {
      var _this = this;
      this.mapClickHandler = evt => {
        console.log("当前点击坐标x,y", evt.coordinate);
        var feature = _this.map.forEachFeatureAtPixel(evt.pixel,
          function (feature) {
            return feature
          })
        // 调用父组件设备详情，通过设备id
        this.showDeviceDetails(feature.deviceId)
      }
      this.map.on('singleclick', this.mapClickHandler)
    },
    // 判断设备图标信息值或坐标是否发生改变
    checkDeviceValueOrPosition() {
      let oldValue = this.deviceListWidthId
      let oldPosition = this.spaceMap.filter(item => item.xoffset && item.yoffset && this.deviceListWidthId[item.deviceId] && this.deviceListWidthId[item.deviceId].typeEngName !== 'PM_WLD')
      // 等待getDeviceListBySpaceIdAndCategoryTagId和getSpaceMap请求执行完
      setTimeout(() => {
        let newValue = this.deviceListWidthId
        let newPosition = this.spaceMap.filter(item => item.xoffset && item.yoffset && this.deviceListWidthId[item.deviceId] && this.deviceListWidthId[item.deviceId].typeEngName !== 'PM_WLD')
        
        // 只有当设备数据或位置真正变化时才更新图标
        if ((JSON.stringify(oldValue) !== JSON.stringify(newValue)) || JSON.stringify(oldPosition) !== JSON.stringify(newPosition)) {
          // 仅更新变化的设备，而不是全部重建
          this.updateChangedDevices(oldValue, newValue, oldPosition, newPosition);
        }
      }, 1300)
    },
    // 新增: 只更新发生变化的设备图标
    updateChangedDevices(oldValue, newValue, oldPosition, newPosition) {
      console.log(oldPosition, newPosition);
      // 如果图层还未创建，则需要全部初始化
      if (!this.iconLayer || !this.map) {
        this.initDevicePointList();
        return;
      }
      
      // 1. 找出需要移除的设备(在老数据中有，新数据中没有)
      const allOldDeviceIds = Object.keys(oldValue || {});
      const allNewDeviceIds = Object.keys(newValue || {});
      
      // 找出需要移除的设备ID
      const removedDeviceIds = allOldDeviceIds.filter(id => !allNewDeviceIds.includes(id));
      
      // 2. 移除不再存在的设备图标
      const source = this.iconLayer.getSource();
      this.featureList = this.featureList.filter(feature => {
        if (removedDeviceIds.includes(feature.deviceId)) {
          source.removeFeature(feature);
          return false;
        }
        return true;
      });
      
      // 3. 更新已有设备或添加新设备
      const deviceIconList = this.spaceMap.filter(item => 
        item.xoffset && item.yoffset && 
        newValue[item.deviceId] && 
        newValue[item.deviceId].typeEngName !== 'PM_WLD'
      );
      
      deviceIconList.forEach(item => {
        // 检查设备是否已经在地图上
        const existingFeature = this.featureList.find(f => f.deviceId === item.deviceId);
        
        if (existingFeature) {
          // 获取新旧设备信息
          const newDeviceInfo = newValue[item.deviceId];
          const oldDeviceInfo = oldValue[item.deviceId];
          
          if (newDeviceInfo) {
            // 检查设备状态或测量点值是否有变化
            const oldPoints = oldDeviceInfo?.deviceMeasuringPointHistoryList || [];
            const newPoints = newDeviceInfo?.deviceMeasuringPointHistoryList || [];
            
            // 检查点位值是否有变化
            let pointsChanged = false;
            
            // 比较长度不同就是变化了
            if (oldPoints.length !== newPoints.length) {
              pointsChanged = true;
            } else {
              // 长度相同，比较每个点位的值
              for (let i = 0; i < newPoints.length; i++) {
                if (newPoints[i].pointValueName !== oldPoints[i].pointValueName) {
                  pointsChanged = true;
                  break;
                }
              }
            }
            
            // 如果设备状态或测量点值有变化，更新样式
            if (newDeviceInfo.status !== oldDeviceInfo?.status || pointsChanged) {
              // 清除旧的样式缓存并更新
              this.updateDeviceStyle(existingFeature, newDeviceInfo);
            }
          }
        } else {
          // 添加新设备
          this.addDevicePoint(item);
          if (this.featureList.length > 0) {
            const lastFeature = this.featureList[this.featureList.length - 1];
            source.addFeature(lastFeature);
          }
        }
      });
    },
    // 新增: 更新设备样式而不重新创建
    updateDeviceStyle(feature, deviceInfo) {
      const deviceMeasuringPointHistoryList = deviceInfo.deviceMeasuringPointHistoryList || [];
      const detailsText = deviceMeasuringPointHistoryList.length > 0 
        ? deviceMeasuringPointHistoryList.map(point => 
          `${point.pointName}：${point.pointValueName}`
          ).join('\n')
        : '';
      
      // 创建新的样式缓存键，确保包含设备状态和测量点值信息
      const statusKey = `${deviceInfo.id}_${deviceInfo.status}`;
      const valueKey = deviceMeasuringPointHistoryList.map(p => `${p.pointName}_${p.pointValueName}`).join('_');
      
      // 更新样式缓存键，加入测量点值信息
      feature.iconOnlyKey = `${statusKey}_${valueKey}_iconOnly`;
      feature.detailsOnlyKey = `${statusKey}_${valueKey}_detailsOnly`;
      feature.hoverStyleKey = `${statusKey}_${valueKey}_hover`;
      
      // 清除旧的样式缓存
      if (!this.styleCache[feature.iconOnlyKey]) {
        this.styleCache[feature.iconOnlyKey] = [
          new Style({
            image: new Icon({
              anchorXUnits: 'fraction',
              anchorOrigin: 'bottom-left',
              anchorYUnits: 'fraction',
              anchor: [0.5, 0],
              src: deviceInfo.status === 0 ? 
                this.$ftpUrl + deviceInfo.icon : 
                this.$ftpUrl + deviceInfo.iconAlarm,
              scale: 1
            }),
            zIndex: 3
          })
        ];
      }
      
      // 创建详情样式
      if (detailsText && !this.styleCache[feature.detailsOnlyKey]) {
        this.styleCache[feature.detailsOnlyKey] = this.createDeviceStyle(deviceInfo, null, detailsText);
      }
      
      // 创建悬停样式
      if (!this.styleCache[feature.hoverStyleKey]) {
        this.styleCache[feature.hoverStyleKey] = this.createDeviceStyle(deviceInfo, feature.deviceName, detailsText);
      }
      
      // 应用对应样式
      feature.hasDetails = deviceMeasuringPointHistoryList.length > 0;
      feature.setStyle(
        feature.hasDetails ? 
          this.styleCache[feature.detailsOnlyKey] : 
          this.styleCache[feature.iconOnlyKey]
      );
    },
    // 添加漏水线集合
    addSlacklineList() {
      // 清除所有漏水线图层
      this.slackLineLayers.forEach(item => {
       this.map && this.map.removeLayer(item)
      })
      this.slackLineLayers = []

      let slackLineDevice = this.spaceMap.filter(item => item.xoffset && item.yoffset && this.deviceListWidthId[item.deviceId] && this.deviceListWidthId[item.deviceId].typeEngName === 'PM_WLD')
      // 开始画线
      slackLineDevice.forEach(item => {
        let deviceInfo = this.deviceListWidthId[item.deviceId];
        let slackLineColor = deviceInfo.status === 0 ? 'green' : 'rgba(191, 40, 49, 0.85)'
        let positionList = []
        let yArray = item.yoffset.split(',');
        let compareX = 0;
        let compareY = 0;
        item.xoffset.split(',').forEach((item, index) => {
          if (index === 0) {
            // 获取图片基准宽高比
            compareX = this.imgx / item
            compareY = this.imgy / yArray[index]
          }
          if (index !== 0) {
            let convertX = parseFloat(item) * compareX
            let convertY = this.imgy - (parseFloat(yArray[index]) * compareY)
            positionList.push([convertX, convertY])
          }
        })
        this.addSlackline(positionList, slackLineColor)
      })
    },
    // 添加漏水线
    addSlackline(positionList, color) {
      let featureLine = new Feature({
        geometry: new LineString(positionList)
      });
      featureLine.setStyle(new Style({
        stroke: new Stroke({
          color: color,
          width: 5
        })
      }))
      let source = new VectorSource()
      source.addFeature(featureLine)
      let layer = new VectorLayer()
      layer.setSource(source)
      // 储存所有漏水线图层源
      this.slackLineLayers.push(layer)
     this.map && this.map.addLayer(layer)
    },
    // 初始化获取当前内景图的宽高，来动态放大缩小地图
    changeSpaceZoom() {
      this.overviewX = this.$refs.overviewMap.clientWidth
      this.overviewY = this.$refs.overviewMap.clientHeight
      // 地图底图宽长用宽为基准，高长用高为基准
      if (this.imgx >= this.imgy) {
        this.initZoom = Math.floor(this.overviewX / this.imgx * 10) / 10
      } else {
        this.initZoom = Math.floor(this.overviewY / this.imgy * 10) / 10
      }
      if (this.overFlag) {
        this.initZoom += this.overZoom
      }
    },
    // 更换空间获取当前内景图的宽高，来动态放大缩小地图
    caleImageInitZoom() {
      this.overviewX = this.$refs.overviewMap.clientWidth
      this.overviewY = this.$refs.overviewMap.clientHeight
      // 地图底图宽长用宽为基准，高长用高为基准
      if (this.imgx >= this.imgy && this.overviewX >= this.imgx) {
        this.initZoom = Math.floor(this.overviewX / this.imgx * 10) / 10
      } else if (this.imgx < this.imgy && this.overviewY >= this.imgy) {
        this.initZoom = Math.floor(this.overviewY / this.imgy * 10) / 10
      } else {
        this.initZoom = this.overZoom
        this.overFlag = true
      }
    },
    // 创建设备样式的辅助方法
    createDeviceStyle(deviceInfo, titleText, detailsText) {
      // 生成缓存键，包含所有会影响渲染的因素
      const cacheKey = `${deviceInfo.id}_${deviceInfo.status}_${titleText || ''}_${detailsText || ''}`;
      
      // 检查缓存是否存在
      if (this.styleCache[cacheKey]) {
        return this.styleCache[cacheKey];
      }
      
      const alarmBgColor = deviceInfo.alarmBgColor;
      const alarmColor = deviceInfo.alarmColor;
      const normalBgColor = deviceInfo.normalBgColor;
      const normalColor = deviceInfo.normalColor;
      const showIcon = deviceInfo.showIcon;
      
      // 创建样式数组
      const styles = [];
      
      // 添加设备图标
      if (showIcon !== false) {
        styles.push(
          new Style({
            image: new Icon({
              anchorXUnits: 'fraction',
              anchorOrigin: 'bottom-left',
              anchorYUnits: 'fraction',
              anchor: [0.5, 0],
              src: deviceInfo.status === 0 ? 
                this.$ftpUrl + deviceInfo.icon : 
                this.$ftpUrl + deviceInfo.iconAlarm,
              scale: 1,
              // 新增: 使用crossOrigin提升缓存效率
              crossOrigin: 'anonymous'
            }),
            // 为悬停状态设置更高的zIndex
            zIndex: titleText ? 10 : 3
          })
        );
      }
      
      // 兼容的圆角矩形绘制函数（替代 roundRect）
      const drawRoundedRect = (ctx, x, y, width, height, radius) => {
        // 如果支持 roundRect，直接使用
        if (ctx.roundRect) {
          ctx.roundRect(x, y, width, height, radius);
          return;
        }
        
        // 否则使用 arcTo 兼容实现
        const minRadius = Math.min(radius, width / 2, height / 2);
        ctx.beginPath();
        ctx.moveTo(x + minRadius, y);
        ctx.lineTo(x + width - minRadius, y);
        ctx.arcTo(x + width, y, x + width, y + minRadius, minRadius);
        ctx.lineTo(x + width, y + height - minRadius);
        ctx.arcTo(x + width, y + height, x + width - minRadius, y + height, minRadius);
        ctx.lineTo(x + minRadius, y + height);
        ctx.arcTo(x, y + height, x, y + height - minRadius, minRadius);
        ctx.lineTo(x, y + minRadius);
        ctx.arcTo(x, y, x + minRadius, y, minRadius);
        ctx.closePath();
      };
      
      // 创建自定义文本样式的Canvas
      const createCustomTextStyle = () => {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        
        // 计算文本宽度和高度
        let titleWidth = 0;
        if (titleText) {
          ctx.font = 'bold 14px Microsoft YaHei';
          titleWidth = ctx.measureText(titleText).width;
        }
        
        const detailLines = detailsText ? detailsText.split('\n') : [];
        ctx.font = '12px Microsoft YaHei';
        const detailWidths = detailLines.map(line => ctx.measureText(line).width);
        
        // 计算总宽度和高度
        const padding = 5;
        const lineHeight = 22;
        const maxWidth = Math.max(titleWidth, ...detailWidths) + (detailsText ? padding * 2 : 16);
        
        // 计算总高度 - 无标题时减少高度
        const titleHeight = titleText ? lineHeight : 0;
        const detailsHeight = detailLines.length > 0 ? detailLines.length * lineHeight : 0;
        const totalHeight = titleHeight + detailsHeight + padding;
        
        // 为边框预留空间，确保边框完全可见
        const borderWidth = 1;
        canvas.width = maxWidth + borderWidth * 2;
        canvas.height = totalHeight + borderWidth * 2;
        
        // 绘制背景
        ctx.fillStyle = (deviceInfo.status === 0 ? normalBgColor : alarmBgColor) || 'rgba(0, 21, 41, 0.9)';
        ctx.beginPath();
        drawRoundedRect(
          ctx,
          borderWidth, 
          borderWidth, 
          maxWidth, 
          totalHeight, 
          4
        );
        ctx.fill();
        
        // 绘制边框
        ctx.strokeStyle = (deviceInfo.status === 0 ? normalColor : alarmColor) || '#0098FF';
        ctx.lineWidth = borderWidth;
        
        // 正确定位边框线条，确保完全在canvas内部
        const offset = borderWidth % 2 === 0 ? 0 : 0.5;
        ctx.beginPath();
        drawRoundedRect(
          ctx,
          borderWidth + offset, 
          borderWidth + offset, 
          maxWidth - borderWidth, 
          totalHeight - borderWidth, 
          4
        );
        ctx.stroke();
        
        // 绘制标题（如果有）
        let yOffset = padding + lineHeight / 2;
        if (titleText) {
          ctx.font = 'bold 14px Microsoft YaHei';
          ctx.textAlign = 'center';
          ctx.textBaseline = 'middle';
          ctx.fillStyle = (deviceInfo.status === 0 ? normalColor : alarmColor) || '#3AA0FF';
          ctx.fillText(
            titleText, 
            (maxWidth / 2) + borderWidth, 
            yOffset
          );
          yOffset += lineHeight;
        }
        
        // 绘制详情内容
        if (detailLines.length > 0) {
          ctx.font = '12px Microsoft YaHei';
          ctx.textAlign = 'center';
          ctx.fillStyle = '#ffffff';
          detailLines.forEach((line, index) => {
            const y = yOffset + index * lineHeight;
            ctx.fillText(line, (maxWidth / 2) + borderWidth, y);
          });
        }
        
        return canvas.toDataURL();
      };

      // 如果有文本内容（标题或详情），则添加文本样式
      if (titleText || detailsText) {
        styles.push(
          new Style({
            image: new Icon({
              src: createCustomTextStyle(),
              anchor: [0.5, 0],
              anchorXUnits: 'fraction',
              anchorYUnits: 'fraction',
              offsetY: 10
            }),
            // 为悬停状态的文本设置更高的zIndex
            zIndex: titleText ? 11 : 2
          })
        );
      }
      
      // 存入缓存
      this.styleCache[cacheKey] = styles;
      return styles;
    },
    // 并行获取数据，减少等待时间
    async initializeMap(spaceId) {
      // 严格检查 spaceId 的有效性
      if (!spaceId || spaceId === '' || spaceId === '0') {
        console.warn('空间ID无效，跳过地图初始化:', spaceId);
        return;
      }
      
      try {
        console.log('开始初始化地图，空间ID:', spaceId);
        
        // 获取空间信息
        const spaceInfoRes = await getSpaceInfoById(spaceId);
        if (!spaceInfoRes || !spaceInfoRes.data) {
          console.error('获取空间信息失败，spaceId:', spaceId);
          // 重置重试计数器，停止设备图标加载尝试
          this._initDevicePointRetryCount = 999;
          return;
        }
        
        this.spaceInfo = spaceInfoRes.data;
        console.log('空间信息获取成功:', this.spaceInfo);
        
        // 并行获取设备列表和空间地图
        const [deviceListRes, spaceMapRes] = await Promise.all([
          getDeviceListBySpaceIdAndCategoryTagId(this.spaceInfo.id, this.categoryTagId),
          getSpaceMap(this.spaceInfo.id)
        ]);
        
        // 处理设备列表
        if (deviceListRes.data) {
          this.deviceList = deviceListRes.data.filter(e => 
            !this.screenDatas.some(item => item.typeCnName === e.typeCnName)
          );
          
          this.deviceListWidthId = {};
          this.deviceListId = [];
          this.deviceList.forEach(device => {
            this.deviceListId.push(device.id);
            this.deviceListWidthId[device.id] = device;
          });
          
          console.log(`设备列表加载完成，共 ${this.deviceList.length} 个设备`);
        } else {
          console.warn('设备列表为空');
        }
        
        // 处理空间地图
        if (spaceMapRes.data) {
          this.spaceMap = spaceMapRes.data;
          console.log(`空间地图加载完成，共 ${this.spaceMap.length} 个点位`);
          
          // 如果地图已初始化，添加漏水线
          if (this.map) {
            this.addSlacklineList();
          }
        } else {
          console.warn('空间地图数据为空');
        }
        
        // 尝试立即初始化地图
        if ((this.spaceInfo && this.spaceInfo.id) && !this.map) {
          console.log('开始初始化地图视图...');
          await this.getBgImageInfoAsync();
          await this.initMap();
          console.log('地图视图初始化完成');
        }
      } catch (error) {
        console.error('初始化地图失败:', error);
        // 停止设备图标加载重试
        this._initDevicePointRetryCount = 999;
      }
    },
    // 使用Promise加载图片并直接计算合适的缩放比例
    async getBgImageInfoAsync() {
      return new Promise((resolve) => {
        const img_url = this.spaceInfo?.bgImage 
        ? this.$ftpUrl + this.spaceInfo.bgImage 
        : require('@/assets/images/no-bg.png');
        
        const img = new Image();
        
        img.onload = () => {
          this.imgy = img.height;
          this.imgx = img.width;
          resolve();
        };
        
        img.onerror = () => {
          this.imgy = 1002;
          this.imgx = 1432;
          console.warn('背景图加载失败，使用默认尺寸');
          resolve();
        };
        
        img.src = img_url;
      });
    },
    // 处理窗口大小变化
    handleResize() {
      if (!this.map) return;
      
      // 延迟执行以确保DOM尺寸已更新
      setTimeout(() => {
        // 使用fit方法重新调整视图
        const extent = [0, 0, this.imgx, this.imgy];
        this.map.getView().fit(extent, {
          size: [this.$refs.overviewMap.clientWidth, this.$refs.overviewMap.clientHeight],
          padding: [10, 10, 10, 10],
          constrainResolution: false
        });
        
        // 触发地图更新
        this.map.updateSize();
      }, 100);
    },
    // 新增: 预加载所有可能用到的图标
    preloadDeviceIcons() {
      // 创建预加载队列
      this.iconPreloadQueue = new Set();
      
      // 监听设备列表更新
      this.$watch('deviceList', (newDeviceList) => {
        // 预加载所有设备图标
        if (Array.isArray(newDeviceList)) {
          newDeviceList.forEach(device => {
            if (device.icon) this.preloadImage(this.$ftpUrl + device.icon);
            if (device.iconAlarm) this.preloadImage(this.$ftpUrl + device.iconAlarm);
          });
        }
      }, { immediate: true });
    },
    // 新增: 预加载单个图片
    preloadImage(src) {
      // 避免重复加载
      if (this.iconPreloadQueue.has(src)) return;
      
      // 添加到预加载队列
      this.iconPreloadQueue.add(src);
      
      // 创建图片对象并加载
      const img = new Image();
      img.onload = () => {
        // 从队列中移除已加载的图片
        this.iconPreloadQueue.delete(src);
      };
      img.onerror = () => {
        // 加载失败也从队列移除
        this.iconPreloadQueue.delete(src);
        console.warn('图标预加载失败:', src);
      };
      img.src = src;
    },
    // 新增: 防抖函数，避免频繁调用
    debounce(func, wait) {
      let timeout;
      return function(...args) {
        const context = this;
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(context, args), wait);
      };
    },
    // 添加缩放事件监听，确保图标在缩放期间保持可见
    enhanceIconsVisibilityDuringZoom() {
      if (!this.map) return;
      
      // 监听视图变化开始
      this.map.getView().on('change:resolution', () => {
        // 确保图标图层在缩放期间保持高渲染优先级
        if (this.iconLayer) {
          // 增加图标层z-index确保缩放时可见
          this.iconLayer.setZIndex(100);
          
          // 确保样式缓存被正确应用
          if (this.featureList && this.featureList.length > 0) {
            this.featureList.forEach(feature => {
              // 重新应用样式确保图标可见
              const styleKey = feature.hasDetails ? 
                feature.detailsOnlyKey : feature.iconOnlyKey;
              
              if (this.styleCache[styleKey]) {
                feature.setStyle(this.styleCache[styleKey]);
              }
            });
          }
        }
        
        // 确保漏水线在缩放期间保持可见
        this.slackLineLayers.forEach(layer => {
          if (layer) layer.setZIndex(99);
        });
      });
      
      // 优化图标图层渲染方式
      // 注意：renderMode、updateWhileAnimating 和 updateWhileInteracting 
      // 是在创建图层时设置的选项，不能动态修改
      // 这些选项已在 addDevicePointList() 方法中创建图层时设置
    },
    // 高亮显示指定设备
    highlightDevice(deviceId) {
      if (!deviceId || !this.featureList || this.featureList.length === 0) {
        return;
      }
      
      // 查找对应的设备要素
      const targetFeature = this.featureList.find(f => f.deviceId === deviceId);
      if (!targetFeature) {
        console.warn('未找到设备:', deviceId);
        return;
      }
      
      this.highlightFeature = targetFeature;
      
      // 将地图中心移动到该设备位置
      const geometry = targetFeature.getGeometry();
      const coordinates = geometry.getCoordinates();
      
      // 平滑移动到设备位置并适当放大
      this.map.getView().animate({
        center: coordinates,
        duration: 1000,
        zoom: Math.max(this.map.getView().getZoom(), 3) // 确保有适当的放大级别
      });
      
      // 创建闪烁效果
      let blinkCount = 0;
      const maxBlinks = 10; // 闪烁5次（显示隐藏各5次）
      
      this.highlightTimer = setInterval(() => {
        if (blinkCount >= maxBlinks) {
          clearInterval(this.highlightTimer);
          this.highlightTimer = null;
          // 恢复正常样式并打开设备详情
          const styleKey = targetFeature.hasDetails ? 
            targetFeature.detailsOnlyKey : targetFeature.iconOnlyKey;
          targetFeature.setStyle(this.styleCache[styleKey]);
          
          // 自动打开设备详情
          setTimeout(() => {
            this.showDeviceDetails(deviceId);
          }, 300);
          return;
        }
        
        // 切换显示/隐藏（通过放大缩小实现闪烁效果）
        if (blinkCount % 2 === 0) {
          // 放大并应用高亮样式
          const highlightStyle = this.createHighlightStyle(targetFeature);
          targetFeature.setStyle(highlightStyle);
        } else {
          // 恢复正常大小
          const styleKey = targetFeature.hasDetails ? 
            targetFeature.hoverStyleKey : targetFeature.iconOnlyKey;
          targetFeature.setStyle(this.styleCache[styleKey]);
        }
        
        blinkCount++;
      }, 400); // 每400ms切换一次
    },
    
    // 创建高亮样式
    createHighlightStyle(feature) {
      const deviceInfo = this.deviceListWidthId[feature.deviceId];
      if (!deviceInfo) return null;
      
      const styles = [];
      
      // 放大的图标
      styles.push(
        new Style({
          image: new Icon({
            anchorXUnits: 'fraction',
            anchorOrigin: 'bottom-left',
            anchorYUnits: 'fraction',
            anchor: [0.5, 0],
            src: deviceInfo.status === 0 ? 
              this.$ftpUrl + deviceInfo.icon : 
              this.$ftpUrl + deviceInfo.iconAlarm,
            scale: 1.5, // 放大1.5倍
            opacity: 1
          }),
          zIndex: 200 // 最高层级
        })
      );
      
      // 添加闪烁的外圈效果
      styles.push(
        new Style({
          image: new Icon({
            anchorXUnits: 'fraction',
            anchorOrigin: 'bottom-left',
            anchorYUnits: 'fraction',
            anchor: [0.5, 0],
            src: deviceInfo.status === 0 ? 
              this.$ftpUrl + deviceInfo.icon : 
              this.$ftpUrl + deviceInfo.iconAlarm,
            scale: 2, // 更大的外圈
            opacity: 0.3
          }),
          zIndex: 199
        })
      );
      
      return styles;
    },
    
    // 预缓存图标资源，减少缩放时的加载延迟
    preloadAllIconResources() {
      // 创建一个图标资源缓存池
      if (!this.iconResourceCache) {
        this.iconResourceCache = {};
      }
      
      // 预加载所有设备图标
      if (this.deviceList && this.deviceList.length > 0) {
        this.deviceList.forEach(device => {
          if (device.icon) {
            const iconUrl = this.$ftpUrl + device.icon;
            if (!this.iconResourceCache[iconUrl]) {
              const img = new Image();
              img.src = iconUrl;
              this.iconResourceCache[iconUrl] = img;
            }
          }
          
          if (device.iconAlarm) {
            const alarmUrl = this.$ftpUrl + device.iconAlarm;
            if (!this.iconResourceCache[alarmUrl]) {
              const img = new Image();
              img.src = alarmUrl;
              this.iconResourceCache[alarmUrl] = img;
            }
          }
        });
      }
    },
  },
  async mounted() {
    // 等待DOM渲染完成
    await this.$nextTick();
    
    // 检查 spaceId 是否有效
    if (this.spaceId && this.spaceId !== '0') {
      // 初始化地图
      await this.initializeMap(this.spaceId);
    } else {
      console.warn('组件加载时spaceId无效，等待有效的spaceId传入:', this.spaceId);
    }
    
    this.$store.dispatch('addIntervalObj', {
      'updateIndoorSetting:10000': () => {
        if (this.spaceInfo && this.spaceInfo.id) {
          this.getDeviceList(this.spaceInfo.id);
        }
      }
    });
    
    // 添加窗口大小变化监听器，自动调整地图
    window.addEventListener('resize', this.debounce(this.handleResize, 200));
  },
  destroyed() {
    this.$store.dispatch('removeIntervalObj', 'updateIndoorSetting')
    // 清除GIS地图中图标更新器
    if (this.updateDeviceIconTimer) {
      clearTimeout(this.updateDeviceIconTimer);
      this.updateDeviceIconTimer = null;
    }
    // 清除高亮定时器
    if (this.highlightTimer) {
      clearInterval(this.highlightTimer);
      this.highlightTimer = null;
    }
    
    // 移除窗口大小变化监听器
    window.removeEventListener('resize', this.handleResize);
  },
  watch: {
    spaceId(newVal) {
      // 检查新的 spaceId 是否有效
      if (!newVal || newVal === '0') {
        console.warn('spaceId变更为无效值，跳过更新:', newVal);
        return;
      }
      
      console.log('spaceId变更，开始更新地图:', newVal);
      
      // 1. 立即清除所有图层和图标集合
      if (this.map) {
        // 立即清空图标集合
        this.featureList = [];
        
        // 立即移除所有图层
        if (this.map.getLayers()) {
          const layers = this.map.getLayers().getArray().slice();
          layers.forEach(layer => {
            this.map.removeLayer(layer);
          });
        }
        
        // 强制地图重绘
        this.map.updateSize();
      }
      
      // 2. 重置数据和重试计数器
      this.spaceMap = [];
      this.deviceList = [];
      this.deviceListWidthId = null;
      this.deviceListId = [];
      this._initDevicePointRetryCount = 0;
      
      // 3. 获取新空间数据
      this.getSpaceInfo(newVal).then(() => {
        // 4. 加载新的地图背景和设备
        if (this.map !== null) {
          this.getBgImageInfo(this.changeDeviceMapImage);
        }
      });
    },
    screenDatas() {
      this.getDeviceList(this.spaceInfo.id);
    },
    categoryTagId() {
      this.deviceList = []
      this.spaceMap = []
      this.getDeviceList(this.spaceId)
      // 初始化图标图层
      if (this.map !== null) {
        this.initDevicePointList();
      }
    },
    highlightDeviceId(newVal) {
      // 当 highlightDeviceId 改变时，如果地图和设备已加载，执行高亮
      if (newVal && this.map && this.featureList && this.featureList.length > 0) {
        setTimeout(() => {
          this.highlightDevice(newVal);
        }, 800);
      }
    }
  }
}
</script>

<style scoped>
.main {
  width: 100%;
  height: 100%;
}

.device-container {
  overflow: scroll;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

::v-deep .ol-rotate {
  /* 设置地图旋转回正按钮位置，避免与全屏按钮重叠*/
  right: 3em;
}

/* 确保OpenLayers图标在缩放时平滑过渡 */
::v-deep .ol-layer {
  transition: opacity 0.05s ease;
}

::v-deep .ol-viewport canvas {
  transform: translateZ(0);  /* 启用硬件加速 */
}

/* 确保加载指示器在缩放时仍然可见 */
.map-loading-indicator {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.2);
  z-index: 10000;  /* 确保高于所有地图元素 */
  pointer-events: none;  /* 允许点击穿透 */
}
</style>
